module.exports = __webpack_public_path__ + "img/bg_home3.2eab4ff6.png";